<ion-content>
	<form [formGroup]="noteForm" *ngIf="ticketNote?.ticketId">
		<ion-item>
			<ion-label position="stacked">Subject</ion-label>
			<ion-input
				formControlName="subject"
				name="subject"
				type="text"
				autofocus="true"
			></ion-input>
		</ion-item>
		<ion-item>
			<ion-label position="stacked">Note</ion-label>
			<ion-textarea
				formControlName="note"
				name="note"
				type="text"
				rows="10"
			></ion-textarea>
			<div
				*ngIf="
					noteForm.controls.note.errors &&
					isValidFormSubmitted != null &&
					!isValidFormSubmitted
				"
				class="error"
			>
				Note must be at least 5 characters long.
			</div>
		</ion-item>
	</form>
</ion-content>

<ion-footer>
	<ion-button
		expand="full"
		class="modal__submit"
		color="primary"
		type="submit"
		(click)="onSaveNote()"
	>
		Add Note
	</ion-button>
</ion-footer>
